export const VIDEOS = Object.freeze({
	SPLASH_SCREEN: "scenes/cabin-splash-screen/video/default_1080p_v01.mp4",
	CABIN_HUB: "scenes/cabin-hub/video/default_1080p_v02.mp4",
	RADIO: "scenes/cabin-radio/video/default_1080p_v02.mp4",
	FIREPLACE: "scenes/cabin-fireplace/video/default_1080p_v02.mp4",
	FIREPLACE_CLOSER: "scenes/cabin-fireplace/video/default_1080p_v01.mp4",
	BOOKSHELF: "scenes/cabin-library/video/default_1080p_v01.mp4",
	CAT: "scenes/cabin-cat/video/default_1080p_v02.mp4",
	LIBRARY: "scenes/cabin-library/video/default_1080p_v01.mp4",
	DESK: "scenes/cabin-desk/video/default_1080p_v02.mp4",
	WINDOW: "scenes/cabin-window/video/default_1080p_v02.mp4",
	COUCH: "scenes/cabin-couch/video/default_1080p_v02.mp4",
	PLANE: "scenes/trvl-plane/video/default_1080p_v01.mp4",
	CABANA: "scenes/cabana-hub/video/default_1080p_v01.mp4",
	CABANA_BEACH: "scenes/cabana-beach/video/default_1080p_v01.mp4",
	PLANE_RETURN: "scenes/trvl-plane-return/video/default_1080p_v01.mp4",
});

export const IMAGES = Object.freeze({
	GAME_TABLE: "scenes/cabin-game-table/image/default_v02.webp",
	DESK: "scenes/cabin-desk/image/default_v02.webp",
	DESK_DRAWER: "scenes/cabin-desk-drawer/image/default_v01.webp",
	CABIN_EXIT: "scenes/cabin-exit/image/default_v01.webp",
	CABIN_KITCHEN: "scenes/cabin-kitchen/image/default_v01.webp",
});
